import { DualPalette } from "../types";

export const text: DualPalette = {
  primary:   { light: "#0f172a", dark: "#dcdddf" },
  secondary: { light: "#475569", dark: "#dcdddf" },
  external:  { light: "#1e293b", dark: "#dcdddf" },
};
